import NetworkRepo from './infrastructure/web-backend/networkRepo.js'
import getSingleData from './applications/getSingleData.js'
import triggerAction from './applications/triggerAction.js'

class DataService {
  static _instance = null

  constructor({ Events: events, sendBugAlert, modal } = {}) {
    if (DataService._instance) return DataService._instance
    DataService._instance = this

    this.events = events
    this.modal = modal
    this.sendBugAlert = sendBugAlert
    this.setupFallbacks()

    this.networkRepo = new NetworkRepo()
  }

  setupFallbacks() {
    if (
      typeof this.events?.dispatch !== 'function' ||
      typeof this.events?.handle !== 'function'
    ) {
      console.warn('Events instance is not valid')
    }
  }

  static getInstance() {
    if (!this._instance) {
      throw new Error(
        'Instance d’OperationService non créée, appelle le constructeur d’abord.',
      )
    }
    return this._instance
  }

  static get events() {
    return this.getInstance().events
  }

  static async getSingleData(dataKey, filters) {
    const instance = DataService.getInstance()
    try {
      const result = await getSingleData(dataKey, filters, instance)
      if (result && result.statusCode === 200 && result.data) {
        if (!window.cachedData) {
          window.cachedData = {}
        }
        window.cachedData[dataKey] = result.data
      }
      return result
    } catch (error) {
      instance.sendBugAlert(error, { filters })
    }
  }

  static async triggerAction(dataKey, params) {
    const instance = DataService.getInstance()
    try {
      return triggerAction(dataKey, params, instance)
    } catch (error) {
      instance.sendBugAlert(error, { params })
    }
  }
}

export default DataService
